import { connect } from 'react-redux';
import * as selectors from '../../redux/selectors';
import { bindActionCreators } from 'redux';
import * as actions from '../../redux/actions';

const mapStateToProps = state => ({
  slots: selectors.getAdSlots(state),
  firms: selectors.firms.options(state),
  reps: selectors.reps.reps(state),
  items: selectors.getListings(state),
  currentAdSlot: selectors.getCurrentAdSlot(state),
  currentRep: selectors.reps.current(state),
  currentFirm: selectors.getCurrentFirm(state),
  currentListing: selectors.getCurrentListing(state),
});

const mapDispatchToProps = dispatch => ({
  adSlotActions: bindActionCreators(actions.adSlot, dispatch),
  showcaseActions: bindActionCreators(actions.showcase, dispatch),
  repActions: bindActionCreators(actions.rep, dispatch),
  listingActions: bindActionCreators(actions.listing, dispatch),
});

const Build = control => connect(mapStateToProps, mapDispatchToProps)(control);

export default Build;
